import { render, staticRenderFns } from "./TodaySales.vue?vue&type=template&id=6f456824&scoped=true"
import script from "./TodaySales.vue?vue&type=script&lang=js"
export * from "./TodaySales.vue?vue&type=script&lang=js"
import style0 from "./TodaySales.vue?vue&type=style&index=0&id=6f456824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f456824",
  null
  
)

export default component.exports